export enum ViewAction {
  Desktop = 'desktop',
  Mobile = 'mobile',
  Rotate = 'rotate',
}
